const ResendVerificationEmail = () => import(/* webpackChunkName: 'ResendVerificationEmail' */ '@/ResendVerificationEmail/Index');

export default [
  {
    path: '/resend-verification-email',
    name: 'resend-verification-email',
    component: ResendVerificationEmail,
    meta: { auth: true },
  },
];
